import React, { useEffect, useState } from "react";
import "./CandidateFormModal.css";
import {
    createCandidate,
    updateCandidate,   // 👈 ADD THIS
    fetchEmployeeOptions
} from "../../api/adminCandidateApi";

const CandidateFormModal = ({ mode, candidate, onClose, onSuccess }) => {
    const isEdit = mode === "edit";

    const [form, setForm] = useState({
        name: candidate?.name || "",
        email: candidate?.email || "",
        username: "",
        phone: candidate?.phone || "",
        assignedToEmployeeId: candidate?.assignedToId || "",
        status: candidate?.status || "ACTIVE"
    });


    const [employees, setEmployees] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        fetchEmployeeOptions()
            .then(res => setEmployees(res.data))
            .catch(() => alert("Failed to load employees"));
    }, []);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            if (isEdit) {
                await updateCandidate(candidate.id, {
                    name: form.name,
                    phone: form.phone,
                    assignedToEmployeeId: form.assignedToEmployeeId || null,
                    status: form.status
                });
            } else {
                if (!form.name || !form.email || !form.username) {
                    alert("Name, Email, Username are required");
                    setSubmitting(false);
                    return;
                }

                await createCandidate({
                    name: form.name,
                    email: form.email,
                    username: form.username,
                    phone: form.phone,
                    assignedToEmployeeId: form.assignedToEmployeeId || null
                });
            }

            onSuccess();
            onClose();
        } catch (err) {
            console.error(err);
            alert("Operation failed");
        } finally {
            setSubmitting(false);
        }
    };


    return (
        <div className="modal-overlay">
            <div className="modal-card">
                <h2>{isEdit ? "Edit Candidate" : "Create Candidate"}</h2>

                <form onSubmit={handleSubmit}>
                    <input
                        name="name"
                        placeholder="Full Name"
                        value={form.name}
                        onChange={handleChange}
                    />

                    <input
                        name="email"
                        placeholder="Email"
                        value={form.email}
                        disabled={isEdit}
                        onChange={handleChange}
                    />

                    <input
                        name="username"
                        placeholder="Username"
                        value={form.username}
                        disabled={isEdit}
                        onChange={handleChange}
                    />

                    <input
                        name="phone"
                        placeholder="Phone (optional)"
                        value={form.phone}
                        onChange={handleChange}
                    />
                    {isEdit && (
                        <select
                            name="status"
                            value={form.status}
                            onChange={handleChange}
                        >
                            <option value="ACTIVE">Active</option>
                            <option value="INACTIVE">Inactive</option>
                        </select>
                    )}


                    <select
                        name="assignedToEmployeeId"
                        value={form.assignedToEmployeeId}
                        onChange={handleChange}
                    >
                        <option value="">Unassigned</option>
                        {employees.map(e => (
                            <option key={e.id} value={e.id}>
                                {e.name} ({e.email})
                            </option>
                        ))}
                    </select>

                    <div className="modal-actions">
                        <button
                            type="button"
                            className="secondary"
                            onClick={onClose}
                        >
                            Cancel
                        </button>

                        <button type="submit" disabled={submitting}>
                            {submitting
                                ? isEdit ? "Saving..." : "Creating..."
                                : isEdit ? "Save Changes" : "Create"}
                        </button>

                    </div>
                </form>
            </div>
        </div>
    );
};

export default CandidateFormModal;
